{
  const more = document.querySelector('[data-more-open]');
  const openMore = document.querySelector('[data-more-button]');   
 
  if (openMore) {
    openMore.onclick = function() {
      more.classList.add('pulse-diagnostics--open');
	  openMore.classList.add('pulse-diagnostics--hide');
    }
  } 
}
